export const BASE_COLOR = {
  // http://tachyons.io/docs/themes/skins/
  black: '#000000',
  nearBlack: '#111111',
  darkGray: '#333333',
  midGray: '#555555',
  gray: '#777777',
  silver: '#999999',
  lightSilver: '#AAAAAA',
  moonGray: '#CCCCCC',
  moonLightGray: '#DDDDDD', // Made up color..
  lightGray: '#EEEEEE',
  nearWhite: '#F4F4F4',
  white: '#FFFFFF',
  darkRed: '#E7040F',
  red: '#FF4136',
  lightRed: '#FF725C',
  orange: '#FF6300',
  gold: '#FFB700',
  yellow: '#FFD700',
  lightYellow: '#FBF1A9',
  purple: '#5E2CA5',
  lightPurple: '#A463F2',
  darkPink: '#D5008F',
  hotPink: '#FF41B4',
  pink: '#FF80CC',
  lightPink: '#FFA3D7',
  darkGreen: '#137752',
  green: '#19A974',
  lightGreen: '#9EEBCF',
  navy: '#001B44',
  darkBlue: '#00449E',
  blue: '#357EDD',
  lightBlue: '#96CCFF',
  lightestBlue: '#CDECFF',
  washedBlue: '#F6FFFE',
  washedGreen: '#E8FDF5',
  washedYellow: '#FFFCEB',
  washedRed: '#FFDFDF',

  // Added for caret color, from iA writer
  caretBlue: '#00baff',
  paperWhite: '#FBFBFB',
  midLightGray: '#666666',
};

// palette name from (http://www.colourlovers.com)
// + color name from (http://www.htmlcsscolor.com)
export const MOA_COLOR = {
  // http://www.colourlovers.com/palette/443995/i_demand_a_pancake
  pancake: {
    matterhorn: '#594F4F',
    blueBayoux: '#547980',
    puertoRico: '#45ADA8',
    chinook: '#9DE0AD',
    snowFlurry: '#E5FCC2',
  },

  // http://www.colourlovers.com/palette/1930/cheer_up_emo_kid
  emokid: {
    shuttleGrey: '#556270',
    mediumTurquoise: '#4ECDC4',
    mindaro: '#C7F464',
    bittersweet: '#FF6B6B',
    mandy: '#C44D58',
  },

  // http://www.colourlovers.com/palette/1811244/1001_Stories
  stories: {
    mandysPink: '#F8B195',
    brinkPink: '#F67280',
    tapestry: '#C06C84',
    affair: '#6C5B7B',
    matisse: '#355C7D',
  },

  // http://www.colourlovers.com/palette/482774/dream_magnet
  magnet: {
    outerSpace: '#343838',
    blueLagoon: '#005F6B',
    easternBlue: '#008C9E',
    irisBlue: '#00B4CC',
    aqua: '#00DFFC',
  },

  // http://www.colourlovers.com/palette/4518051/Freak_out
  freakOut: {
    pacificBlue: '#019CD2',
    honeyFlower: '#5B406B',
    mediumRedViolet: '#B32474',
    razzmatazz: '#DB0066',
    turbo: '#FFC61A',
  },
};


export const FEEDBACK_COLOR = {
  meh: BASE_COLOR.midGray,

  // From reapop-theme-wybo.
  info: '#349ef3',
  error: '#f5311d',
  success: '#4dc657',
  warning: '#f5aa0a',
};



// WEBPACK FOOTER //
// ./src/shared/constants/colors.js